import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "../Header.module.scss";
import mobStyles from "../NavMenu/MobMenu/MobMenu.module.scss";
import BagIcon from "@/components/Logos/Bag";
import { isDonationProduct, isGiftCardType  } from "@/helpers/pdpHelpers/priceHelpers";
import { reportError } from "@/helpers/errorHelper";
import Srcset from "@/components/common/Srcset";

function Bag({isSuper,classProp, isPWA}) {
  const cart_list = useSelector((state) => state.click.cart_list);
  const filledBag = "images/Icons/Bag-item.svg"; //for filled - "images/Icons/Bag-item.svg"
  const emptyBag = "images/Icons/Bag.svg"; //for filled - "images/Icons/Bag.svg"
  const [isEmpty, setIsEmpty] = useState(true);
  let [bagIcon, setBagIcon] = useState(emptyBag);
  let [bagQuantity, setBagQuantity] = useState(null);

  useEffect(() => {
    if (cart_list) {
      let lineItems = cart_list?.lines?.edges;
      let numTotalItems;
      if (lineItems) {
        try {
          numTotalItems = lineItems.reduce((previousValue, currentValue) => {
            if(isDonationProduct(currentValue.node.merchandise.product) || isGiftCardType(currentValue?.node?.merchandise)){
              return previousValue + currentValue.node.quantity
            }else{
              return previousValue + (currentValue.node?.merchandise?.quantityAvailable ? currentValue.node.quantity : 0);
            }
          }, 0);
        }
        catch(error) {
          reportError("error computing the numTotalItems in bag");
          reportError(error);
        }
      }

      setBagQuantity(numTotalItems);

      let isEmpty =
        typeof numTotalItems !== "undefined" ? numTotalItems <= 0 : true;

      isEmpty ? setBagIcon(emptyBag) : setBagIcon(filledBag);
      setIsEmpty(isEmpty);
    } else {
      setBagQuantity(0)
      setIsEmpty(true)
      setBagIcon(emptyBag);
    }
  }, [cart_list]);
  return (
    <>
      <div className={styles.bag_wrapper} tabIndex={0} onClick={() => {// redirect to /your-bag page for desktop
        window.location.href = "/your-bag"
      }}>
        {
          isPWA ? (
            <Srcset
              requirePath={true}
              svgFile={true}
              src={isEmpty ? "images/Icons/Bag.svg" : "images/Icons/Bag-item.svg"}
              alt="Bag"
              height={"19"}
              width={"22"}
              className={classProp}
              dataga4={"App: Bag"}
            />
          ) : (
            <>
              {isEmpty && <BagIcon classProp={classProp} stroke={isSuper ? "#ffffff" : "#2f2f30"} fill_top="none" fill_bottom="none" />}
              {!isEmpty &&
                <BagIcon classProp={classProp} stroke={isSuper ? "#ffffff" : "#2f2f30"} fill_top={isSuper ? "none" : "#ffffff"} fill_bottom={isSuper ? "#ffffff" : "2f2f30"} />
              }   
            </>
          )
        }
        {/* ga tracking for bag icon click */}
        {bagQuantity > 0 && (
          <span
            className={`xxx-small italic ga-bag-icon-click bg-mink ${styles["bag-count"]} ${mobStyles["bag-count"]}`}
          >
            {bagQuantity > 99 ? "9+" : bagQuantity}
          </span>
        )}
      </div>
    </>
  );
}

export default Bag;
